import { FC, useCallback } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { useGetAuthenticatedUserQuery, useGetConfigQuery } from "src/api";
import { routes } from "src/app/routes";
import logo from "src/assets/uniqa_logo.svg";
import { Flex, Icon, Icons, UnstyledButton } from "src/components";
import { navigateExternal } from "src/utils";
import { useLogout } from "./query";

export const HeaderContent: FC = () => {
    const { data: config } = useGetConfigQuery();
    const { data, isLoading, isError } = useGetAuthenticatedUserQuery();
    const isAdmin = !isLoading && data?.roles?.some((role) => config?.adminRoleNames.includes(role));

    return (
        <>
            <Link to={isError ? routes.accessDenied.path : routes.dashboard.path}>
                <Icon icon={logo} height={80} width={220} alt="UNIQA logo" withAnimation />
            </Link>
            <Flex gap="1.5rem">
                <Link to={isError ? routes.accessDenied.path : routes.subscriptions.path}>
                    <Icon icon={Icons.ProfileIcon} height={80} width={40} alt="Profil" withAnimation />
                </Link>
                <Logout />
                {isAdmin && (
                    <Link to={isError ? routes.accessDenied.path : routes.userManagement.path}>
                        <IconWrapper>
                            <Icon icon={Icons.ManagementIcon} height={50} width={50} alt="Správa uživatelů" withAnimation />
                        </IconWrapper>
                    </Link>
                )}
            </Flex>
        </>
    );
};

const Logout = () => {
    const { data: config } = useGetConfigQuery();
    const [logout] = useLogout();

    const { protocol, host } = window.location;
    const redirectUri = `${protocol}//${host}`;

    const onLogout = useCallback(async () => {
        await logout();
        navigateExternal(config!.keycloak.logoutUri, {
            redirect_uri: redirectUri,
        });
    }, [config, logout, redirectUri]);

    return (
        <UnstyledButton onClick={() => onLogout()}>
            <Icon icon={Icons.LogoutIcon} height={80} width={32} alt="Odhlásit" withAnimation />
        </UnstyledButton>
    );
};

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`;
